const MEDIASOUP_CONFIG = {
  protooProtocol: process.env.VUE_APP_PROTOO_PROTOCOL,
  protooHost: process.env.VUE_APP_PROTOO_HOST,
  protooPort: process.env.VUE_APP_PROTOO_PORT
}

export default MEDIASOUP_CONFIG
